// extracted by mini-css-extract-plugin
export default {"agentSkillsContainer":"ccf-agent-skills_agentSkillsContainer__EB5Jj","skillsTitle":"ccf-agent-skills_skillsTitle__I+Xng"};